import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { usePermissions } from '../../contexts/PermissionContext';

/**
 * Banner global que aparece quando admin está simulando outro papel.
 * Deve ser renderizado no topo da aplicação.
 */
export function SimulationBanner() {
  const { 
    isSimulating, 
    impersonatedRole, 
    baseRole, 
    setImpersonatedRole,
    simulationLoading 
  } = usePermissions();

  if (!isSimulating) return null;

  return (
    <div className="bg-gradient-to-r from-yellow-500/20 via-amber-500/20 to-yellow-500/20 border-b border-yellow-500/30 px-4 py-2">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-4 h-4 text-yellow-400" />
          <span className="text-sm text-yellow-200">
            <span className="font-medium">Modo Simulação:</span>
            {' '}Você está visualizando como{' '}
            <span className="font-bold text-yellow-400">
              {impersonatedRole}
            </span>
            {simulationLoading && (
              <span className="ml-2 text-xs text-yellow-400/70">(carregando permissões...)</span>
            )}
          </span>
        </div>
        <button
          onClick={() => setImpersonatedRole(null)}
          className="flex items-center gap-1 px-2 py-1 text-xs bg-yellow-500/20 hover:bg-yellow-500/30 text-yellow-300 rounded border border-yellow-500/30 transition-colors"
        >
          <X className="w-3 h-3" />
          Encerrar
        </button>
      </div>
    </div>
  );
}

